import React from 'react'
import { Route, IndexRoute } from 'react-router'
import Splitter from '../helpers/Splitter'

const OnlineTestContainer = Splitter(() =>
  import('../components/common/onlineTests/OnlineTestContainer')
)
const Index = Splitter(() => import('../components/common/onlineTests/Index'))

const CreateOnlineTest = Splitter(() => import('../components/manager/CreateOnlineTest'))

const ViewTestContainer = Splitter(() =>
  import('../components/common/onlineTests/ViewTestContainer')
)

const SchoolSelectStudentsForTest = Splitter(() =>
  import('../components/school/SchoolSelectStudentsForTest.js')
)

const TakeTheTestContainer = Splitter(() =>
  import('../components/common/onlineTests/TakeTheTestContainer.js')
)

const TestResult = Splitter(() =>
  import('../components/common/onlineTests/TestResult.js')
)

const ManagerAddQuestion = Splitter(() =>
  import('../components/manager/ManagerAddQuestion')
)

export const onlineTestRoutes = (
  <Route path="online-tests" component={OnlineTestContainer}>
    <IndexRoute component={Index} />
    <Route path="create" component={CreateOnlineTest} />
    <Route path="view/:testId/:testCode" component={ViewTestContainer} />
    <Route path="purchase/:testId/:serviceCode" component={SchoolSelectStudentsForTest} />
    <Route path="take/:testId" component={TakeTheTestContainer} />
    <Route path="results/:testId" component={TestResult} />
    <Route path="manager-add-question" component={ManagerAddQuestion} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes/onlineTestRoutes.js